import deepmerge from 'deepmerge';
import { editableTheme as baseEditableTheme } from '@truvity/widget__forms-mui-theme';
import { LinkedVcClaimDef, NumericStringClaimDef, TextareaClaimDef } from '@truvity/widget__vcs-builder';
import { FieldBuiltinRenderers } from '@truvity/widget__forms';

import { LinkedCredential } from './renderers/LinkedCredential';
import { TextareaField } from './renderers/TextareaField';
import { NumericStringField } from './renderers/NumericStringField';
import { FileField } from './renderers/FileField';

export const editableTheme = deepmerge(baseEditableTheme, {
    builtinRenderers: {
        [FieldBuiltinRenderers.File]: FileField,
    },
    typeRenderers: {
        [LinkedVcClaimDef.rendererName]: LinkedCredential,
        [TextareaClaimDef.rendererName]: TextareaField,
        [NumericStringClaimDef.rendererName]: NumericStringField,
    },
});
